export default __webpack_public_path__ + "static/media/logo-grupo-ser-negro.60685377.png";